export const LOCAL_STORAGE_IS_ACCEPT_COOKIE = 'LOCAL_STORAGE_IS_ACCEPT_COOKIE';